<script>
    import {
        changeToSentenceCase,
        getEmailValidation,
        getPhoneValidation,
    } from "../../../../../Utils/utilFunctions.svelte";
    import {
        addErrorInput,
        removeErrorInput,
    } from "../../../helpers/encounterUtils.svelte";

    export let 
        index,
        patientContactDetails = {},
        patientEncounterDetails = {};

    $: isValidEmail = patientContactDetails.email
          ? getEmailValidation(patientContactDetails.email)
          : true;

    $: isValidPhone = patientContactDetails.phone
          ? getPhoneValidation(patientContactDetails.phone)
          : true;

    let errInputs = [];

    export const checkValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    // HELPER FUNCTIONS
    const _updateInvalidFieldsStyle = () => {
        if(patientContactDetails.useAsContact){
            //is use as contact so check that all fields are filled
            if(!patientContactDetails.name){
                errInputs = addErrorInput(`contactNameInput-${index}`, errInputs, "Contact name");
            } else {
                errInputs = removeErrorInput(`contactNameInput-${index}`, errInputs);
            }

            if(!patientContactDetails.relationship) {
                errInputs = addErrorInput(
                    `contactRelationshipInput-${index}`,
                    errInputs,
                    "Contact relationship"
                );
            } else {
                errInputs = removeErrorInput(
                    `contactRelationshipInput-${index}`,
                    errInputs,
                );
            }

            if(!patientContactDetails.email){
                 errInputs = addErrorInput(`contactEmailInput-${index}`, errInputs, "Contact email");
            } else {
                if (!isValidEmail)
                    errInputs = addErrorInput(`contactEmailInput-${index}`, errInputs);
                else
                    errInputs = removeErrorInput(`contactEmailInput-${index}`, errInputs);
            }

            if(!patientContactDetails.phone){
                errInputs = addErrorInput(`contactPhoneInput-${index}`, errInputs, "Contact phone");
            } else {
                if (!isValidPhone)
                    errInputs = addErrorInput(`contactPhoneInput-${index}`, errInputs, "Contact phone");
                else 
                    errInputs = removeErrorInput(`contactPhoneInput-${index}`, errInputs);
            }
        }
        else {
            errInputs = removeErrorInput(`contactNameInput-${index}`, errInputs);
            errInputs = removeErrorInput(`contactRelationshipInput-${index}`, errInputs);
            errInputs = removeErrorInput(`contactEmailInput-${index}`, errInputs);
            errInputs = removeErrorInput(`contactPhoneInput-${index}`, errInputs);

            if (!isValidEmail)
                errInputs = addErrorInput(`contactEmailInput-${index}`, errInputs);

            if (!isValidPhone)
                errInputs = addErrorInput(`contactPhoneInput-${index}`, errInputs);

            if(patientContactDetails.email  || patientContactDetails.phone){
                //if at least one of these 2 are filled, then name should be filled
                if(!patientContactDetails.name)
                    errInputs = addErrorInput(`contactNameInput-${index}`, errInputs, "Contact name");
                else
                    errInputs = removeErrorInput(`contactNameInput-${index}`, errInputs);
            }
        }
    };

</script>

<div class="flex flex-1 flex-col gap-4">
    <div class="flex flex-col flex-1 w-full gap-4">
        <div class="flex flex-1 gap-2">
            <div class="flex-1 flex items-start">
                <p class="title">Name:</p>
                <input
                    type="text"
                    id={`contactNameInput-${index}`}
                    placeholder="Contact Name"
                    class="input w-remaining input-sm input-bordered"
                    autocomplete="off"
                    bind:value={patientContactDetails.name}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                        target.placeholder = "Contact Name";
                    }}
                    on:focusout={() => {
                        patientContactDetails.name = changeToSentenceCase(
                            patientContactDetails.name,
                        );
                    }}
                />
            </div>
            <div class="flex-1 flex items-start">
                <p class="title">Email:</p>
                <div class="flex flex-col w-remaining">
                    <input
                        type="text"
                        id={`contactEmailInput-${index}`}
                        placeholder="Contact person's email"
                        class="input w-full input-sm input-bordered"
                        autocomplete="off"
                        bind:value={patientContactDetails.email}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Contact person's email";
                        }}
                    />

                    {#if !isValidEmail}
                        <label class="label">
                            <span class="label-text-alt text-error">
                                Invalid email
                            </span>
                        </label>
                    {/if}
                </div>
            </div>
        </div>
        <div class="flex flex-1 flex-row gap-2">
            <div class="flex-1 flex items-start">
                <p class="title">Relationship:</p>
                <input
                    type="text"
                    id={`contactRelationshipInput-${index}`}
                    placeholder="Relationship"
                    class="input w-remaining input-sm input-bordered"
                    autocomplete="off"
                    bind:value={patientContactDetails.relationship}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                        target.placeholder = "Relationship";
                    }}
                />
            </div>
            <div class="flex-1 flex items-start">
                <p class="title">Phone:</p>
                <div class="flex flex-col flex-1">
                    <input
                        type="text"
                        id={`contactPhoneInput-${index}`}
                        placeholder="Contact person's phone"
                        class="input w-full input-sm input-bordered"
                        autocomplete="off"
                        bind:value={patientContactDetails.phone}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Contact person's phone";
                        }}
                        on:blur={() =>
                            (patientContactDetails.phone =
                                patientContactDetails.phone?.replaceAll(
                                    " ",
                                    "",
                                ))}
                    />

                    {#if !isValidPhone}
                         <label class="label">
                            <span class="label-text-alt text-error">
                                Invalid phone
                            </span>
                        </label>
                    {/if}
                </div>
            </div>
        </div>
    </div>

    <div class="form-control items-center flex flex-row gap-x-4">
        <div class="form-control items-center flex flex-row gap-x-4">
            <input
                type="checkbox"
                id={`disableNotifications-${index}`}
                class="toggle toggle-secondary"
                autocomplete="off"
                bind:checked={patientEncounterDetails.disableNotifications}
            />
            <label for="disableNotifications" class="cursor-pointer">
                Disable communications
            </label>

        </div>
        <div class="form-control items-center flex flex-row gap-x-4">
            <input
                type="checkbox"
                id={`useAsContactCheckbox-${index}`}
                class="toggle toggle-secondary"
                autocomplete="off"
                bind:checked={patientContactDetails.useAsContact}
            />
            <label
                for="useAsContactCheckbox"
                class="cursor-pointer"
            >
                Use contact person for communications
            </label>
        </div>
    </div>

    <div class="flex w-full">
        <p class="title">Patient note:</p>
        <input
            type="text"
            id="patientNotes"
            placeholder="Add a note"
            class="input w-remaining input-sm input-bordered"
            autocomplete="off"
            bind:value={patientEncounterDetails.notes}
        />
    </div>
</div>

<style>
    .title {
        width: 160px;
    }

    .w-remaining {
        width: calc(100% - 160px);
    }
</style>

